import React from "react"
import Drawer from "./Drawer"
import { useState } from "react"
import Footer from "../../components/Footer"
import ChevronRight from "../../assets/Images/icons/ChevronRight"

const DashboardContainer = ({ children }) => {
  const [mobileMenu, setmobileMenu] = useState(true)

  return (
    <>
      <div className="flex flex-1  bg-[rgb(252,248,242)]">
        <Drawer isDrawerOpen={mobileMenu} />
        <div className="flex min-h-[100vh] flex-col w-[100dvw] px-[24px] xl:px-[80px]">
          {/* <div className="mt-[120px]">
            <div className="flex mt-[-80px] mb-[80px] gap-[39px] justify-between">
              <OtherUserDetails />
              <div className="flex gap-[12px]">
                <EMIDueSection />
              </div>
            </div>
          </div> */}
          <div className="mt-[20px]">
            <div
              className={`hidden  lg:flex xl:hidden justify-center items-center rounded-full text-white bg-primary h-[28px] w-[28px] `}
              onClick={() => setmobileMenu(!mobileMenu)}
            >
              <span
                className={`transition-transform duration-600 transform ${
                  mobileMenu ? "rotate-[180deg]" : "rotate-0"
                }`}
              >
                <ChevronRight />
              </span>
            </div>
          </div>
          <div className="mt-[10px]">{children}</div>
        </div>
      </div>
      {/* <MobileNavbar mobileMenu={mobileMenu} setmobileMenu={setmobileMenu}>
        <Drawer />
      </MobileNavbar> */}
      <div className="bg-[rgb(252,248,242)] pt-[180px] pb-[50px]">
        <Footer custumeClass="landing-page-footer !bg-inherit !border-0"/>
      </div>
    </>
  )
}

export default DashboardContainer
